<template>
  <div class="settings">
    <breadcrumbs />
    <div class="profile">

<!--       <rp-autocomplete-field
        type="text"
        title="Add Hospital(s):"
        :options="hospitalOptions"
        option-text="label"
        option-value="value"
        v-model="hospital"
        @input="addHospital"
        placeholder="Select">
          Add a hospital
        </rp-autocomplete-field> -->

      <div v-if="usersHospitals.length" class="rp-top-bar-title">List of your hospitals:</div>

      <div v-for="hospital in usersHospitals" :key="hospital.value" class="info-item">
        <span>{{hospital.label}}</span>
        <rp-sprite name="delete_outline" @click.native="removeHospital(hospital)"/>
      </div>
    </div>
  </div>
</template>

<script>
import {getHospitals} from 'raypro_ui/src/api/hospitals'

import {getUserHospitals, deleteUserHospitals, createUserHospitals} from 'raypro_ui/src/api/users'

// import RpAutocompleteField from 'raypro_ui/src/components/ui/form-elements/AutocompleteField'
import RpSprite from 'raypro_ui/src/components/ui/Sprite'
import Breadcrumbs from '@/components/Breadcrumbs'

export default {
  components: {
    // RpAutocompleteField,
    Breadcrumbs,
    RpSprite
  },

  data() {
    return {
      hospital: '',
      hospitalOptions: [],
      usersHospitals: []
    }
  },
  mounted() {
    this.getHospitals()
    this.getUserHospitals()
  },
  computed: {
    getUserId() {
      return this.$store.getters.authUser.id
    }
  },

  methods: {
    getUserHospitals() {
      const id = this.getUserId

      getUserHospitals({id}).then((res) => {
        const response = res.data
        const blob = response.map((h) => {
          return {
            label: h.name,
            value: h.id
          }
        })

        this.usersHospitals = blob
      })
    },
    getHospitals() {
      getHospitals().then((res) => {
        const response = res.data

        const hospitalOptions = response.map((h) => {
          return {
            label: h.name,
            value: h.id
          }
        })

        this.hospitalOptions = hospitalOptions
      })
    },
    removeHospital(hospital) {
      const hospitalId = hospital.value
      const payload = {
        id: this.getUserId,
        hospitalId
      }

      deleteUserHospitals(payload)
        .then(() => {
          this.getUserHospitals()
        })
    },
    addHospital(val) {
      if(val) {
        const hospitalId = val.value
        const payload = {
          id: this.getUserId,
          hospitalId
        }

        createUserHospitals(payload).then(() => {
          this.getUserHospitals()
        })
      }
    },
    submit() {

    }
  }
}
</script>

<style lang="sass" scoped>
@import 'raypro_ui/src/styles/base/_variables.sass'
@import 'raypro_ui/src/styles/helpers/_mixins.sass'

.settings
  .profile
    position: relative
    padding: 4rem
    padding-bottom: 7.5rem
    min-height: 64.5rem
    width: 75rem
    background-color: $color-panel-bg
    box-shadow: 0 2px 7px 0 $color-shadow

    .info-item
      width: 100%
      display: flex
      font-size: 1.6rem
      margin-bottom: 10px
      margin-top: 10px
      margin-left: 20px
      color: $color-side-nav

      span:nth-of-type(1)
        width: 30%
        font-weight: $font-regular

      .sprite
        width: 20px
        height: 20px
        fill: $color-error
        cursor: pointer

</style>



// WEBPACK FOOTER //
// src/components/pages/Settings/MyHospitals.vue